import React from 'react';
import { motion } from 'framer-motion';
export function Divider() {
  return <motion.div initial={{
    opacity: 0,
    scaleX: 0
  }} whileInView={{
    opacity: 1,
    scaleX: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className="flex items-center justify-center gap-3 my-12" data-id="element-65" data-mp="1gbs4h19jxohb">
      <div className="h-px bg-gradient-to-r from-transparent via-[#E0B756] to-transparent w-24" data-id="element-66" data-mp="sects51vcqii"></div>
      <div className="w-2 h-2 rounded-full bg-[#E0B756]" data-id="element-67" data-mp="xc4hsnze7shf"></div>
      <div className="h-px bg-gradient-to-r from-transparent via-[#E0B756] to-transparent w-24" data-id="element-68" data-mp="xeqzhgfzzodd"></div>
    </motion.div>;
}